<div class="flex flex-row gap-[30px]">
  <div>
    <div class="fht-header">
      {{ '+COMMISSIONING.DEVICE.FLOOR_HEATING_THERMOSTAT' | translate }}
      <span>{{ getFhtId(fhtDeviceId | idPrefixRemover) | serialSpacing }}</span>
    </div>
    <vi-program-item
      *ngIf="damageProtectionThreshold$ | async | ready as feature"
      [hasTemperature]="true"
    >
      <div class="temperature-select-container" item *ngIf="feature | executable: 'setValue'">
        <app-temperature-select
          data-at-fht-damage-protection-threshold
          [title]="'+INSTALLATIONS.SRC.ETRV.DAMAGE_PROTECTION_THRESHOLD.TITLE' | translate"
          matTooltip="{{ '+INSTALLATIONS.SRC.ETRV.DAMAGE_PROTECTION_THRESHOLD.TITLE' | translate }}"
          matTooltipPosition="above"
          [rangeDefinition]="feature | constraints: 'setValue':'value'"
          [value]="feature?.properties?.value?.value"
          (valueChange)="onDamageProtectionThresholdChange($event, feature.feature)"
        ></app-temperature-select>
      </div>
      <vi-item
        *ngIf="!(feature | executable: 'setValue')"
        item
        [title]="'+INSTALLATIONS.SRC.ETRV.DAMAGE_PROTECTION_THRESHOLD.TITLE' | translate"
        [value]="feature?.properties?.value?.value"
      ></vi-item>
    </vi-program-item>
    <ng-container *ngIf="gatewayDevices$ | async | ready as gatewayDevicesFeature">
      <div class="channels-header">{{ '+SRC.DEVICE.SMART_ZIGBEE_FHT_CHANNELS' | translate }}:</div>
      <ng-container
        *ngFor="
          let channelId of getFhtChannelsIds(gatewayDevicesFeature?.properties?.devices?.value)
        "
      >
        <div
          class="channel-container"
          *ngIf="getFhtChannelValve(channelId) | async | ready as channelFeature"
        >
          <div class="channel-id">
            {{ channelId | idPrefixRemover | serialSpacing }}
          </div>
          <div>
            <mat-radio-group
              *ngIf="assignValveValue(channelId, channelFeature)"
              [(ngModel)]="channelsValveOpenOrClosed[channelId]"
              [class.deactivated]="!(channelFeature | executable: 'setType')"
              class="flex flex-col"
            >
              <vi-radio-button
                [viConfirm]="{
                  title: '+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_TYPE_CHANGE_MODAL_TITLE' | translate,
                  content:
                    '+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_TYPE_CHANGE_MODAL_TITLE_CONTENT'
                    | translate,
                  cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
                  confirmBtn: 'GENERAL.BUTTON.CONFIRM' | translate
                }"
                gtm="onChange"
                gtmAction="Floor heating channel valve type"
                gtmCategory="fhtManager"
                gtmLabel="normallyOpened"
                (confirm)="onChannelValveChange('normallyOpened', channelId)"
                (cancel)="onCancelChannelValveChange()"
                value="normallyOpened"
                [label]="'+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_TYPE_OPEN' | translate"
                [checked]="'normallyOpened' === channelsValveOpenOrClosed[channelId]"
                [disabled]="true"
              ></vi-radio-button>
              <vi-radio-button
                [viConfirm]="{
                  title: '+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_TYPE_CHANGE_MODAL_TITLE' | translate,
                  content:
                    '+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_TYPE_CHANGE_MODAL_TITLE_CONTENT'
                    | translate,
                  cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
                  confirmBtn: 'GENERAL.BUTTON.CONFIRM' | translate
                }"
                gtm="onChange"
                gtmAction="Floor heating channel valve type"
                gtmCategory="fhtManager"
                gtmLabel="normallyClosed"
                (confirm)="onChannelValveChange(NormallyOpenedClosed.normallyClosed, channelId)"
                (cancel)="onCancelChannelValveChange()"
                value="normallyClosed"
                [label]="'+INSTALLATIONS.SRC.FHT_CHANNEL.VALVE_TYPE_CLOSED' | translate"
                [checked]="'normallyClosed' === channelsValveOpenOrClosed[channelId]"
                [disabled]="true"
              ></vi-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
